// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Card from "../components/Card/Card.bs.js";
import * as Chip from "../components/Chip/Chip.bs.js";
import * as Link from "../components/Link/Link.bs.js";
import * as Tabs from "../components/Tabs/Tabs.bs.js";
import * as Alert from "../components/Alert/Alert.bs.js";
import * as Badge from "../components/Badge/Badge.bs.js";
import * as Input from "../components/Input/Input.bs.js";
import * as Prose from "../components/Prose/Prose.bs.js";
import * as Stack from "../components/Stack/Stack.bs.js";
import * as React from "react";
import * as Avatar from "../components/Avatar/Avatar.bs.js";
import * as Button from "../components/Button/Button.bs.js";
import * as Select from "../components/Select/Select.bs.js";
import * as Switch from "../components/Switch/Switch.bs.js";
import * as Divider from "../components/Divider/Divider.bs.js";
import * as Emotion from "../bindings/Emotion.bs.js";
import * as Skeleton from "../components/Skeleton/Skeleton.bs.js";
import * as Textarea from "../components/Textarea/Textarea.bs.js";
import * as FormField from "../components/FormField/FormField.bs.js";
import * as Blockquote from "../components/Blockquote/Blockquote.bs.js";
import * as IconButton from "../components/IconButton/IconButton.bs.js";
import * as Typography from "../components/Typography/Typography.bs.js";
import * as ArticleMeta from "../components/ArticleMeta/ArticleMeta.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

let Components = {
  Button: undefined,
  Input: undefined,
  Textarea: undefined,
  Select: undefined,
  Switch: undefined,
  Card: undefined,
  Typography: undefined,
  Divider: undefined,
  Avatar: undefined,
  Badge: undefined,
  Blockquote: undefined,
  Alert: undefined,
  Tabs: undefined,
  Skeleton: undefined,
  Link: undefined,
  Stack: undefined,
  FormField: undefined,
  Prose: undefined,
  ArticleMeta: undefined,
  IconButton: undefined,
  Chip: undefined
};

function ComponentsPage$DemoCard(props) {
  return JsxRuntime.jsxs(Card.Card.make, {
    variant: "outlined",
    className: Emotion.Css.css({
      minWidth: "0"
    }),
    children: [
      JsxRuntime.jsx(Card.Card.Header.make, {
        children: JsxRuntime.jsx(Typography.Typography.Heading.make, {
          level: "h3",
          children: props.title
        })
      }),
      JsxRuntime.jsx(Card.Card.Body.make, {
        children: props.children
      })
    ]
  });
}

let DemoCard = {
  make: ComponentsPage$DemoCard
};

function ComponentsPage$Stack(props) {
  return JsxRuntime.jsx(Stack.Stack.make, {
    gap: 4,
    children: props.children
  });
}

let Stack$1 = {
  make: ComponentsPage$Stack
};

function ComponentsPage$Row(props) {
  return JsxRuntime.jsx(Stack.Stack.make, {
    direction: "horizontal",
    gap: 3,
    align: "center",
    wrap: true,
    children: props.children
  });
}

let Row = {
  make: ComponentsPage$Row
};

function ComponentsPage$Grid(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: Emotion.Css.css({
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
      gap: "1.5rem"
    })
  });
}

let Grid = {
  make: ComponentsPage$Grid
};

let formValue = (function(evt) { return evt.target.value });

function ComponentsPage$ActionsDemo(props) {
  return JsxRuntime.jsxs(ComponentsPage$Grid, {
    children: [
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Variants",
        children: JsxRuntime.jsxs(ComponentsPage$Stack, {
          children: [
            JsxRuntime.jsx(Button.Button.make, {
              variant: "primary",
              children: "Primary"
            }),
            JsxRuntime.jsx(Button.Button.make, {
              variant: "secondary",
              children: "Secondary"
            }),
            JsxRuntime.jsx(Button.Button.make, {
              variant: "outline",
              children: "Outline"
            }),
            JsxRuntime.jsx(Button.Button.make, {
              variant: "ghost",
              children: "Ghost"
            }),
            JsxRuntime.jsx(Button.Button.make, {
              variant: "danger",
              children: "Danger"
            })
          ]
        })
      }),
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Sizes and states",
        children: JsxRuntime.jsxs(ComponentsPage$Stack, {
          children: [
            JsxRuntime.jsxs(ComponentsPage$Row, {
              children: [
                JsxRuntime.jsx(Button.Button.make, {
                  size: "xs",
                  children: "XS"
                }),
                JsxRuntime.jsx(Button.Button.make, {
                  size: "sm",
                  children: "SM"
                }),
                JsxRuntime.jsx(Button.Button.make, {
                  size: "md",
                  children: "MD"
                }),
                JsxRuntime.jsx(Button.Button.make, {
                  size: "lg",
                  children: "LG"
                })
              ]
            }),
            JsxRuntime.jsx(Button.Button.make, {
              loading: true,
              children: "Saving"
            }),
            JsxRuntime.jsx(Button.Button.make, {
              disabled: true,
              children: "Disabled"
            }),
            JsxRuntime.jsx(Button.Button.make, {
              variant: "outline",
              fullWidth: true,
              children: "Full width"
            })
          ]
        })
      }),
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Links and icon buttons",
        children: JsxRuntime.jsxs(ComponentsPage$Stack, {
          children: [
            JsxRuntime.jsxs(ComponentsPage$Row, {
              children: [
                JsxRuntime.jsx(Link.Link.make, {
                  href: "/posts",
                  children: "Inline link"
                }),
                JsxRuntime.jsx(Link.Link.make, {
                  href: "/about",
                  variant: "nav",
                  children: "Nav link"
                }),
                JsxRuntime.jsx(Link.Link.make, {
                  href: "/journal",
                  variant: "subtle",
                  children: "Subtle link"
                })
              ]
            }),
            JsxRuntime.jsxs(ComponentsPage$Row, {
              children: [
                JsxRuntime.jsx(IconButton.IconButton.make, {
                  label: "New entry",
                  children: "＋"
                }),
                JsxRuntime.jsx(IconButton.IconButton.make, {
                  label: "Catalog",
                  variant: "ghost",
                  children: "☰"
                }),
                JsxRuntime.jsx(IconButton.IconButton.make, {
                  label: "Write",
                  variant: "primary",
                  children: "✎"
                })
              ]
            })
          ]
        })
      })
    ]
  });
}

let ActionsDemo = {
  make: ComponentsPage$ActionsDemo
};

function ComponentsPage$FormsDemo(props) {
  let match = React.useState(() => "");
  let setInputValue = match[1];
  let match$1 = React.useState(() => "");
  let setNotes = match$1[1];
  let match$2 = React.useState(() => "private");
  let setVisibility = match$2[1];
  let match$3 = React.useState(() => true);
  let setAllowComments = match$3[1];
  return JsxRuntime.jsxs(ComponentsPage$Grid, {
    children: [
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Input",
        children: JsxRuntime.jsxs(ComponentsPage$Stack, {
          children: [
            JsxRuntime.jsx(Input.Input.make, {
              variant: "default",
              placeholder: "Default input",
              value: match[0],
              onChange: evt => {
                let value = formValue(evt);
                setInputValue(param => value);
              }
            }),
            JsxRuntime.jsx(Input.Input.make, {
              variant: "filled",
              placeholder: "Filled input"
            }),
            JsxRuntime.jsx(Input.Input.make, {
              variant: "outlined",
              placeholder: "Outlined input"
            }),
            JsxRuntime.jsx(Input.Input.make, {
              variant: "flushed",
              placeholder: "Flushed input"
            }),
            JsxRuntime.jsx(Input.Input.make, {
              state: "error",
              placeholder: "Needs a title"
            }),
            JsxRuntime.jsx(Input.Input.make, {
              state: "success",
              placeholder: "Looks ready"
            })
          ]
        })
      }),
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Textarea",
        children: JsxRuntime.jsx(Textarea.Textarea.make, {
          placeholder: "Write a margin note…",
          value: match$1[0],
          onChange: evt => {
            let value = formValue(evt);
            setNotes(param => value);
          },
          ariaLabel: "Margin notes"
        })
      }),
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Select",
        children: JsxRuntime.jsx(Select.Select.make, {
          options: [
            {
              value: "private",
              label: "Private"
            },
            {
              value: "unlisted",
              label: "Unlisted"
            },
            {
              value: "public",
              label: "Public"
            }
          ],
          value: match$2[0],
          onChange: evt => {
            let value = formValue(evt);
            setVisibility(param => value);
          },
          ariaLabel: "Visibility"
        })
      }),
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Switch",
        children: JsxRuntime.jsxs(ComponentsPage$Stack, {
          children: [
            JsxRuntime.jsx(Switch.Switch.make, {
              checked: match$3[0],
              onChange: next => setAllowComments(param => next),
              label: "Allow comments"
            }),
            JsxRuntime.jsx(Switch.Switch.make, {
              checked: false,
              disabled: true,
              label: "Archived"
            })
          ]
        })
      }),
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Form field",
        children: JsxRuntime.jsx(FormField.FormField.make, {
          label: "Dek",
          htmlFor: "dek-demo",
          hint: "A short line under the title.",
          required: true,
          children: JsxRuntime.jsx(Input.Input.make, {
            placeholder: "The architecture of silence",
            id: "dek-demo"
          })
        })
      })
    ]
  });
}

let FormsDemo = {
  make: ComponentsPage$FormsDemo
};

function ComponentsPage$FeedbackDemo(props) {
  return JsxRuntime.jsxs(ComponentsPage$Grid, {
    children: [
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Alert",
        children: JsxRuntime.jsxs(ComponentsPage$Stack, {
          children: [
            JsxRuntime.jsx(Alert.Alert.make, {
              variant: "info",
              title: "Desk",
              children: "Sign in to write in the journal."
            }),
            JsxRuntime.jsx(Alert.Alert.make, {
              variant: "success",
              title: "Saved",
              children: "The entry is on the desk."
            }),
            JsxRuntime.jsx(Alert.Alert.make, {
              variant: "warning",
              title: "Draft",
              children: "Title and body both need a little ink."
            }),
            JsxRuntime.jsx(Alert.Alert.make, {
              variant: "error",
              title: "Could not save",
              children: "The mock server did not accept the entry."
            })
          ]
        })
      }),
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Badge",
        children: JsxRuntime.jsxs(ComponentsPage$Row, {
          children: [
            JsxRuntime.jsx(Badge.Badge.make, {
              children: "Default"
            }),
            JsxRuntime.jsx(Badge.Badge.make, {
              variant: "primary",
              children: "ReScript"
            }),
            JsxRuntime.jsx(Badge.Badge.make, {
              variant: "success",
              children: "Published"
            }),
            JsxRuntime.jsx(Badge.Badge.make, {
              variant: "warning",
              children: "Draft"
            }),
            JsxRuntime.jsx(Badge.Badge.make, {
              variant: "error",
              children: "Archived"
            })
          ]
        })
      }),
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Skeleton",
        children: JsxRuntime.jsxs(ComponentsPage$Stack, {
          children: [
            JsxRuntime.jsxs(ComponentsPage$Row, {
              children: [
                JsxRuntime.jsx(Skeleton.Skeleton.make, {
                  variant: "circle"
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(Skeleton.Skeleton.make, {
                    variant: "title"
                  }),
                  className: Emotion.Css.css({
                    flex: "1"
                  })
                })
              ]
            }),
            JsxRuntime.jsx(Skeleton.Skeleton.Stack.make, {
              count: 3
            }),
            JsxRuntime.jsx(Skeleton.Skeleton.make, {
              variant: "block"
            })
          ]
        })
      })
    ]
  });
}

let FeedbackDemo = {
  make: ComponentsPage$FeedbackDemo
};

function ComponentsPage$EditorialDemo(props) {
  return JsxRuntime.jsxs(ComponentsPage$Grid, {
    children: [
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Typography",
        children: JsxRuntime.jsxs(ComponentsPage$Stack, {
          children: [
            JsxRuntime.jsx(Typography.Typography.Display.make, {
              size: "lg",
              children: "Display Text"
            }),
            JsxRuntime.jsx(Typography.Typography.Heading.make, {
              level: "h2",
              children: "Heading Text"
            }),
            JsxRuntime.jsx(Typography.Typography.Body.make, {
              children: "Body text with line height for a long journal entry."
            }),
            JsxRuntime.jsx(Typography.Typography.Caption.make, {
              children: "Caption for dates and asides"
            }),
            JsxRuntime.jsx(Typography.Typography.Overline.make, {
              children: "Overline"
            })
          ]
        })
      }),
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Avatar",
        children: JsxRuntime.jsxs(ComponentsPage$Row, {
          children: [
            JsxRuntime.jsx(Avatar.Avatar.make, {
              name: "Alice Chen",
              size: "sm"
            }),
            JsxRuntime.jsx(Avatar.Avatar.make, {
              name: "Bob Martinez",
              size: "md"
            }),
            JsxRuntime.jsx(Avatar.Avatar.make, {
              name: "Carol Davis",
              size: "lg"
            })
          ]
        })
      }),
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Blockquote",
        children: JsxRuntime.jsx(Blockquote.Blockquote.make, {
          cite: "Rich Hickey",
          children: "Simplicity is a prerequisite for reliability."
        })
      }),
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Chips",
        children: JsxRuntime.jsxs(ComponentsPage$Row, {
          children: [
            JsxRuntime.jsx(Chip.Chip.make, {
              children: "#thoughts"
            }),
            JsxRuntime.jsx(Chip.Chip.make, {
              active: true,
              children: "#design"
            }),
            JsxRuntime.jsx(Chip.Chip.make, {
              children: "#architecture"
            })
          ]
        })
      }),
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Card variants",
        children: JsxRuntime.jsxs(ComponentsPage$Stack, {
          children: [
            JsxRuntime.jsx(Card.Card.make, {
              variant: "filled",
              padding: "sm",
              children: JsxRuntime.jsx(Typography.Typography.Caption.make, {
                children: "Filled"
              })
            }),
            JsxRuntime.jsx(Card.Card.make, {
              variant: "elevated",
              padding: "sm",
              children: JsxRuntime.jsx(Typography.Typography.Caption.make, {
                children: "Elevated"
              })
            }),
            JsxRuntime.jsx(Card.Card.make, {
              variant: "outlined",
              padding: "sm",
              children: JsxRuntime.jsx(Typography.Typography.Caption.make, {
                children: "Outlined"
              })
            })
          ]
        })
      })
    ]
  });
}

let EditorialDemo = {
  make: ComponentsPage$EditorialDemo
};

function ComponentsPage$ReadingDemo(props) {
  return JsxRuntime.jsxs(ComponentsPage$Grid, {
    children: [
      JsxRuntime.jsxs(ComponentsPage$DemoCard, {
        title: "Article meta",
        children: [
          JsxRuntime.jsx(ArticleMeta.ArticleMeta.make, {
            author: "Alice Chen",
            date: "Sunday, August 23, 2026",
            location: "Studio"
          }),
          JsxRuntime.jsx(Typography.Typography.Caption.make, {
            children: "Author, date, and optional place in the reading pane."
          })
        ]
      }),
      JsxRuntime.jsx(ComponentsPage$DemoCard, {
        title: "Prose",
        children: JsxRuntime.jsxs(Prose.Prose.make, {
          dropCap: true,
          children: [
            JsxRuntime.jsx(Prose.Prose.Title.make, {
              children: "The Architecture of Silence"
            }),
            JsxRuntime.jsx(Prose.Prose.Paragraph.make, {
              children: "There is a specific quality to the quiet here in the early hours. It is not an absence of sound, but a presence of stillness."
            }),
            JsxRuntime.jsx(Prose.Prose.Paragraph.make, {
              children: "The stepping stones force you to look down, which naturally clears the mind of broader anxieties."
            })
          ]
        })
      })
    ]
  });
}

let ReadingDemo = {
  make: ComponentsPage$ReadingDemo
};

function ComponentsPage(props) {
  let sectionStyles = Emotion.Css.css({
    padding: "4rem 1rem 5rem",
    maxWidth: "1100px",
    margin: "0 auto"
  });
  return JsxRuntime.jsxs("section", {
    children: [
      JsxRuntime.jsx(Typography.Typography.Display.make, {
        size: "3xl",
        align: "center",
        children: "Component Library"
      }),
      JsxRuntime.jsx(Typography.Typography.Body.make, {
        size: "lg",
        align: "center",
        className: Emotion.Css.css({
          marginTop: "1rem",
          color: Emotion.Utils.Color.textSecondary
        }),
        children: "The Journal kit: actions, forms, feedback, editorial type, and the reading pane."
      }),
      JsxRuntime.jsx(Tabs.Tabs.make, {
        tabs: [
          {
            id: "actions",
            label: "Actions",
            content: JsxRuntime.jsx(ComponentsPage$ActionsDemo, {})
          },
          {
            id: "forms",
            label: "Forms",
            content: JsxRuntime.jsx(ComponentsPage$FormsDemo, {})
          },
          {
            id: "feedback",
            label: "Feedback",
            content: JsxRuntime.jsx(ComponentsPage$FeedbackDemo, {})
          },
          {
            id: "editorial",
            label: "Editorial",
            content: JsxRuntime.jsx(ComponentsPage$EditorialDemo, {})
          },
          {
            id: "reading",
            label: "Reading",
            content: JsxRuntime.jsx(ComponentsPage$ReadingDemo, {})
          }
        ],
        className: Emotion.Css.css({
          marginTop: "2.5rem"
        })
      }),
      JsxRuntime.jsx(Divider.Divider.make, {
        label: "Reading type"
      }),
      JsxRuntime.jsx(Typography.Typography.Caption.make, {
        align: "center",
        children: "IBM Plex for UI. Playfair Display for the journal itself."
      })
    ],
    className: sectionStyles
  });
}

let make = ComponentsPage;

export {
  Components,
  DemoCard,
  Stack$1 as Stack,
  Row,
  Grid,
  formValue,
  ActionsDemo,
  FormsDemo,
  FeedbackDemo,
  EditorialDemo,
  ReadingDemo,
  make,
}
/* Card Not a pure module */
